var _rect, _circle, _circle2, _circle3, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourseCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Curso sem imagem de capa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "#F1F5FA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1104,
    cy: 126,
    r: 202,
    fill: "#E7ECF4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 646,
    r: 152,
    fill: "#E7ECF4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1156,
    cy: 574,
    r: 62,
    fill: "#E7ECF4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 640,
    cy: 522,
    rx: 245,
    ry: 21,
    fill: "#E1E7F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M640 241 C 591 215, 501 204, 420 216 L 420 466 C 501 454, 591 465, 640 491 Z",
    fill: "#FFFFFF",
    stroke: "#CCD2E0",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M640 241 C 689 215, 779 204, 860 216 L 860 466 C 779 454, 689 465, 640 491 Z",
    fill: "#FFFFFF",
    stroke: "#CCD2E0",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M459 283 C 515 274, 576 281, 612 295",
    stroke: "#CCD2E0",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M459 333 C 515 324, 576 331, 612 345",
    stroke: "#CCD2E0",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M459 383 C 504 376, 548 380, 579 388",
    stroke: "#CCD2E0",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M821 283 C 765 274, 704 281, 668 295",
    stroke: "#CCD2E0",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M821 333 C 765 324, 704 331, 668 345",
    stroke: "#CCD2E0",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M821 383 C 776 376, 732 380, 701 388",
    stroke: "#CCD2E0",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M640 241 L 640 491",
    stroke: "#CCD2E0",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M732 209 L 732 311 L 761 285 L 790 311 L 790 201 Z",
    fill: "#8894AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseCover);
export default __webpack_public_path__ + "static/media/course-cover.cc38adc476fa64870d77f44bd5792bb5.svg";
export { ForwardRef as ReactComponent };